import React from 'react';
import CountUp from 'react-countup';

export const Percents = ({ color, icon, percent }) => {
  return (
    <>
      <span className={`${icon} ${color}`} />
      <CountUp
        end={percent}
        duration={2}
        className={`card-counter-text-percent-number ${color}`}
        suffix=' %'
        delay={1}
      />
    </>
  );
};
